"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DefaultDevicePixelRatioMonitor = /*#__PURE__*/function () {
  function DefaultDevicePixelRatioMonitor(devicePixelRatioSource, logger) {
    var _this = this;

    _classCallCheck(this, DefaultDevicePixelRatioMonitor);

    this.devicePixelRatioSource = devicePixelRatioSource;
    this.observerQueue = new Set();

    this.mediaQueryListener = function () {
      _this.observerQueue.forEach(function (tileObserver) {
        tileObserver.devicePixelRatioChanged(_this.devicePixelRatioSource.devicePixelRatio());
      });
    };

    if (typeof window === 'undefined') {
      return;
    }

    var mediaQueryList = matchMedia("(resolution: ".concat(this.devicePixelRatioSource.devicePixelRatio(), "dppx)"));

    if (typeof mediaQueryList.addEventListener === 'function') {
      mediaQueryList.addEventListener('change', this.mediaQueryListener);
      this.mediaQueryList = mediaQueryList;
    } else if (typeof mediaQueryList.addListener === 'function') {
      mediaQueryList.addListener(this.mediaQueryListener);
      this.mediaQueryList = mediaQueryList;
    } else {
      logger.warn('ignoring DefaultDevicePixelRatioMonitor');
    }
  }

  _createClass(DefaultDevicePixelRatioMonitor, [{
    key: "destroy",
    value: function destroy() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee() {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.mediaQueryList) {
                  if (typeof this.mediaQueryList.addEventListener === 'function') {
                    this.mediaQueryList.removeEventListener('change', this.mediaQueryListener);
                  } else {
                    this.mediaQueryList.removeListener(this.mediaQueryListener);
                  }
                }

                delete this.mediaQueryListener;
                this.observerQueue.clear();

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "registerObserver",
    value: function registerObserver(observer) {
      this.observerQueue.add(observer);
      observer.devicePixelRatioChanged(this.devicePixelRatioSource.devicePixelRatio());
    }
  }, {
    key: "removeObserver",
    value: function removeObserver(observer) {
      this.observerQueue.delete(observer);
    }
  }]);

  return DefaultDevicePixelRatioMonitor;
}();

exports.default = DefaultDevicePixelRatioMonitor;